'use client'

/**
 * Supabase 클라이언트 공통 모듈 (클라이언트 전용)
 * 
 * 브라우저 환경에서 사용하는 Supabase 클라이언트를 제공합니다.
 * 
 * ⚠️ 이 파일은 클라이언트 전용입니다. 서버 컴포넌트나 서버 액션에서는 사용하지 마세요.
 * 
 * @example
 * // 브라우저에서 사용
 * import { createClient } from '@/supabase'
 * const supabase = createClient()
 * 
 * 서버 사이드에서는 @/supabase/supabase-server를 직접 import하세요:
 * @example
 * // 서버 컴포넌트에서 사용
 * import { createClient } from '@/supabase/supabase-server'
 * import { cookies } from 'next/headers'
 * 
 * const cookieStore = await cookies()
 * const supabase = createClient(cookieStore)
 */

// 브라우저 클라이언트 (클라이언트 컴포넌트 전용)
import { createClient } from './supabase-client'
export { createClient }

// 하위 호환성을 위한 export
export { createClient as createBrowserClient }

// 타입 재export
export type { Database } from '@/types/supabase'
export type { SupabaseClient } from '@supabase/supabase-js'

